export const content = {
  heading: "Contribute By Filling Survey",
  bodyStart: "Few minutes of your time can help save lives.",
  body: "This data would help us understand the spread, recovery, and behavior of the disease which will help in giving insights into better preparing for the next pandemic wave.",
  bodyEnd: "The survey is anonymous and powered by PathCheck.",
  surveyLink:
    "https://docs.google.com/forms/d/e/1FAIpQLSeLbqEj9yhmtHfeH_bOcx49nWpWYeVl2kXd7Vo27H46o8yLxQ/viewform",
};
